import "./ClickSoak.scss"

export default function ClickSoak() {
    return <div className="click-soak">
    </div>
}